import { ValuePropsSection } from './ValuePropsSection';

export default ValuePropsSection;
